import themes from 'devextreme/ui/themes';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLicense } from '@syncfusion/ej2-base';
import { AppModule } from './app/app.module';

registerLicense('Ngo9BigBOggjHTQxAR8/V1NMaF1cW2hIfEx1RHxQdld5ZFRHallYTnNWUj0eQnxTdEBjW35XcHdVRGFeWEd/XA==');

themes.initialized(() => {
  platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
    .catch(err => console.error(err));
});
